import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/navigation/breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/rss-feeds/news-feed.tsx");
